export type CoreEnum =
    | CoreButtonEnum
    | CoreInputEnum
    | CoreTextEnum
    | CoreCheckboxEnum
    | CoreSwitchEnum
    | CoreDividerEnum
    | CoreImageEnum
    | CoreLayoutEnum
    | CoreListEnum;

export enum CoreButtonEnum {
    CORE_BUTTON = 'CoreButton',
}

export enum CoreInputEnum {
    CORE_INPUT = 'CoreInput',
}

export enum CoreTextEnum {
    CORE_TEXT = 'CoreText',
}
export enum CoreCheckboxEnum {
    CORE_CHECKBOX = 'CoreCheckbox',
}
export enum CoreSwitchEnum {
    CORE_SWITCH = 'CoreSwitch',
}
export enum CoreDividerEnum {
    CORE_DIVIDER = 'CoreDivider',
}
export enum CoreImageEnum {
    CORE_IMAGE = 'CoreImage',
}
export enum CoreLayoutEnum {
    CORE_LAYOUT = 'CoreLayout',
}

export enum CoreListEnum {
    CORE_LIST = 'CoreList',
}
